export default __webpack_public_path__ + "static/media/sj.cc842bf6.svg";